import useGetGroup from './useGetGroup';

export default useGetGroup;
export * from './useGetGroup';
